export const CARD_CLASSES = [
  {
    bg: "dual-radial-bg1",
    border:
      "border-border_brand_transparent20 hover:border-border_brand_transparent50",
    color: "text-content_brand_primary",
  },
  {
    bg: "dual-radial-bg2",
    border:
      "border-border_accent1_solid/15 hover:border-border_accent1_solid/25",
    color: "text-content_accent1_primary",
  },
  {
    bg: "dual-radial-bg3",
    border:
      "border-border_accent4_solid/15 hover:border-border_accent4_solid/25",
    color: "text-content_accent4_primary",
  },
  {
    bg: "dual-radial-bg4",
    border:
      "border-content_accent3_primary/15 hover:border-content_accent3_primary/25",
    color: "text-content_accent3_primary",
  },
];
